import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../components/helpers/LazyAction'
import StatePresenter from '../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const usePlacesState = () => React.useContext(Context) || {}
export const usePlaces = () => usePlacesState()?.places || []

const QUERY = gql`
  query Places($page: Int, $limit: Int, $search: String, $sort: PlaceSort, $filter: PlaceFilter) {
    places(page: $page, limit: $limit, search: $search, sort: $sort, filter: $filter) {
      id
      name
      resume
      type
    }
  }
`

const PlacesLoader = ({ children, search, filter, perPage: limit, uncontrolledChildren }) => {
  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      limit: limit || 24,
      search,
      sort: { field: 'NAME', type: 'ASC' },
      filter
    },
    client: placesClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default PlacesLoader
